import { useEffect, useState } from "react";
import type { AiCreditsResponse } from "@edu/shared";
import * as api from "../../lib/api.ts";
import { CREDITS_HEADING, creditsTitleText } from "./side-credits-text.ts";

/**
 * Полоска кредитов ИИ в боковой панели (решение владельца 08.09.2026).
 *
 * Сосед полоски хранилища и устроен так же: своя лёгкая ручка, один запрос при
 * появлении, молчаливое проглатывание отказа. Причина того же устройства не
 * подражание, а смысл: и то, и другое это выданный человеку РЕСУРС со своим
 * знаменателем, и второй язык для того же смысла заставлял бы читать полоску
 * заново.
 *
 * ⚠️ **Это ЕДИНСТВЕННОЕ место продукта, где показан остаток ИИ.** До 08.09.2026
 * их было три: панель сочинения писала «осталось 198 сочинений», панель вычитки
 * «осталось 198 наборов вопросов», а экран озвучки считал знаки. Первые два
 * числа были оценкой по выдуманной средней цене нажатия, и оба сняты вместе с
 * ручками, которые их считали. Заводя счётчик остатка где-то ещё, сначала
 * ответьте, чем он отличается от этого.
 *
 * ⚠️ **Отказ проглатывается молча и блок просто не рисуется**, ровно как у
 * хранилища. Полоска это справка, а не работа: красная строка «не удалось
 * прочитать кредиты» на каждом экране кабинета говорила бы о поломке, которой
 * для дела человека нет. Заодно это делает выкатку безопасной: вкладка с новым
 * бандлом на старом API просто не покажет полоску.
 *
 * ⚠️ **Тревожным цветом не красим ни при каком остатке**, как и запас знаков на
 * экране озвучки: кредиты кончаются у того, кто много работал, и красная полоса
 * читается как выговор.
 *
 * ⚠️ **Компонент живёт в СТАРТОВОМ чанке** вместе со всем сайдбаром, поэтому за
 * ним не должно уехать ничего тяжёлого: тексты лежат в своём файле рядом, схема
 * ответа это три числа и строка (`@edu/shared/ai-credits.ts`).
 */
export function SideCredits() {
  const [credits, setCredits] = useState<AiCreditsResponse | null>(null);

  useEffect(() => {
    let alive = true;
    api
      .aiCredits()
      .then((next) => {
        if (alive) setCredits(next);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  if (credits === null) return null;

  return (
    <div className="side__quota" title={creditsTitleText(credits)}>
      <div className="side__quota-head">
        <span>{CREDITS_HEADING}</span>
        {/*
          Занято и всего, как у хранилища строкой выше. Остаток человек читает
          вычитанием и длиной полосы, и отдельного числа под них не заводится:
          три числа в строке шириной в сайдбар не помещаются, а выбор между
          «занято» и «осталось» тут решает соседство, а не правило.
        */}
        <span>
          {credits.spent} / {credits.quota}
        </span>
      </div>
      <progress max={credits.quota} value={Math.min(credits.spent, credits.quota)} />
    </div>
  );
}
